import { useSearchParams } from 'react-router-dom';

const INVITE_MODAL_QUERY = 'invitations';
export function useInviteModal() {
    const [searchParams, setSearchParams] = useSearchParams();
    const invitesRemaining = searchParams.get(INVITE_MODAL_QUERY);
    const open = !!invitesRemaining;

    function openModal(invitationsRemaining: number) {
        searchParams.set(INVITE_MODAL_QUERY, String(invitationsRemaining));
        setSearchParams(searchParams);
    }
    function closeModal() {
        searchParams.delete(INVITE_MODAL_QUERY);
        setSearchParams(searchParams);
    }
    return { open, closeModal, openModal };
}
